import { SettingsPermissions } from "@redotech/account-common/permissions";
import { useRequiredContext } from "@redotech/react-util/context";
import { useTranslation } from "@redotech/redo-i18n";
import StarIcon from "@redotech/redo-icons/star-01.svg";
import StarFilledIcon from "@redotech/redo-icons/star-01_filled.svg";
import { useHasPermission } from "@redotech/redo-merchant-app-common/auth/permissions-context";
import { MerchantRoutesContext } from "@redotech/redo-merchant-app-common/merchant-routes";
import { RedoSecondaryNavItem } from "@redotech/redo-web/arbiter-components/navigation/secondary/redo-secondary-nav-item";
import { memo } from "react";
import { useMatch } from "react-router-dom";

export const CsatItems = memo(function CsatItems() {
  const { t } = useTranslation();
  const routes = useRequiredContext(MerchantRoutesContext);

  const canManageCsat = useHasPermission(
    SettingsPermissions.SET_SUPPORT_SETTINGS,
  );

  const csatBaseUrl = `${routes.supportBaseUrl}/csat`;
  const anyChildSelected = useMatch(`${csatBaseUrl}/*`);

  if (!canManageCsat) {
    return null;
  }

  return (
    <RedoSecondaryNavItem
      action={{ type: "button" }}
      anyChildSelected={!!anyChildSelected}
      FilledIcon={StarFilledIcon}
      friendlyName={t("CSAT", { context: "customer support navigation label" })}
      id="csat"
      UnfilledIcon={StarIcon}
    >
      <RedoSecondaryNavItem
        action={{ type: "link", href: `${csatBaseUrl}/general` }}
        friendlyName={t("General", {
          context:
            "customer satisfaction settings navigation label for general configuration",
        })}
        id="csat-general"
      />
      <RedoSecondaryNavItem
        action={{ type: "link", href: `${csatBaseUrl}/template` }}
        friendlyName={t("Templates", {
          context:
            "customer satisfaction settings navigation label for survey templates",
        })}
        id="csat-template"
      />
      <RedoSecondaryNavItem
        action={{ type: "link", href: `${csatBaseUrl}/ab-tests` }}
        friendlyName={t("A/B test", {
          context:
            "customer satisfaction navigation label for survey A/B testing",
        })}
        id="csat-ab-tests"
      />
    </RedoSecondaryNavItem>
  );
});
